import { render } from "./kios-details.vue?vue&type=template&id=0667b491&scoped=true"
import script from "./kios-details.vue?vue&type=script&lang=js"
export * from "./kios-details.vue?vue&type=script&lang=js"

import "./kios-details.vue?vue&type=style&index=0&id=0667b491&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0667b491"]])

export default __exports__